import * as React from 'react'
import { useForm, Control, Controller } from 'react-hook-form'

import { InputDate as Presenter, IProps as IPresenterProps } from './presenter'
import { useInitialize } from '@/hooks/useInitialize'

interface IProps
  extends Omit<
    IPresenterProps,
    | 'isInitialized'
    | 'inputDate'
    | 'isOpen'
    | 'setDateHandler'
    | 'setTodayHandler'
    | 'setTomorrowHandler'
    | 'resetHandler'
    | 'submitHandler'
    | 'openHandler'
    | 'closeHandler'
  > {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  control: Control<any>
}

interface IState {
  date: Date
}

export const InputDate = React.forwardRef<HTMLInputElement, IProps>(
  ({ defaultDate, name, control, ...props }, _): JSX.Element => {
    const [isInitialized] = useInitialize()
    const [isOpen, setIsOpen] = React.useState(false)
    const useFormObject = useForm<IState>({
      defaultValues: {
        date: defaultDate,
      },
    })
    const { setValue, reset, watch } = useFormObject
    const inputDate = watch('date')

    const setDateHandler = (date: Date) => {
      setValue('date', date)
    }

    const setTodayHandler = (date: Date) => {
      setDateHandler(date)
    }

    const setTomorrowHandler = (date: Date) => {
      setDateHandler(date)
    }

    const resetHandler = () => {
      reset()
    }

    const openHandler = () => {
      setIsOpen(true)
    }

    const closeHandler = () => {
      setIsOpen(false)
    }

    return (
      <Controller
        name={name}
        control={control}
        {...props}
        render={({ field: { onChange } }) => {
          const submitHandler = () => {
            const inputDate = watch('date')
            onChange(inputDate)
            closeHandler()
          }

          return (
            <Presenter
              {...props}
              isInitialized={isInitialized}
              defaultDate={defaultDate}
              inputDate={inputDate}
              isOpen={isOpen}
              setDateHandler={setDateHandler}
              setTodayHandler={setTodayHandler}
              setTomorrowHandler={setTomorrowHandler}
              resetHandler={resetHandler}
              submitHandler={submitHandler}
              openHandler={openHandler}
              closeHandler={closeHandler}
            />
          )
        }}
      />
    )
  },
)

export default InputDate
